import * as R from 'ramda';
export const findFromData = R.curry((key, value, collection) => R.o(R.find(R.propEq(key, value)), R.propOr([], 'data'))(collection));
export default findFromData;
